import { Folder } from "lucide-react";
import { cn } from "@repo/utils";
import type { Props as InputProps } from "../input";
import { inputVariants } from "../input-variants.js";

type Props = Pick<InputProps, "variant" | "inputSize" | "className" | "disabled" | "error"> & {
  value?: string;
  placeholder: string;
  onClick: () => void;
};

export const DirectoryTrigger = ({
  value,
  placeholder,
  onClick,
  disabled,
  error,
  variant,
  inputSize,
  className,
}: Props) => {
  return (
    <div className="group relative cursor-pointer" onClick={onClick}>
      <div
        className={cn(
          inputVariants({ variant: error ? "error" : variant, inputSize }),
          "flex items-center truncate pr-10 text-gray-700 select-none",
          disabled && "cursor-not-allowed bg-gray-50 opacity-50",
          className
        )}
      >
        {value ? (
          <div className="flex items-center gap-2">
            <span className="truncate text-[12px]">{value}</span>
          </div>
        ) : (
          <span className="text-[12px] text-gray-400">{placeholder}</span>
        )}
      </div>
      {!disabled && (
        <Folder
          size={18}
          className={cn(
            "absolute top-1/2 right-3 -translate-y-1/2 text-gray-400 transition-colors",
            !disabled && "group-hover:text-gray-600"
          )}
        />
      )}
    </div>
  );
};
